import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Resources', path: '/resources' },
    { name: 'Contact', path: '/contact' }
  ];

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div 
            onClick={() => handleNavigation('/')}
            className="flex items-center cursor-pointer transform hover:scale-105 transition-transform"
          >
            <img 
              src="https://static.readdy.ai/image/8335385e15f4d3c6bfe86bf615acf614/e305c7033231f282cf6665e2c60adc76.png" 
              alt="Everstead Logo" 
              className="h-16"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className="text-gray-700 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap transition-colors relative group"
              >
                {item.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-600 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            <button
              onClick={() => handleNavigation('/client-portal')}
              className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 hover:scale-105 transition-all cursor-pointer whitespace-nowrap shadow-md"
            >
              Client Portal
            </button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700 transition-transform ${isMenuOpen ? 'rotate-90' : ''}`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg font-medium cursor-pointer transition-all"
              >
                {item.name}
              </button>
            ))}
            <button
              onClick={() => handleNavigation('/client-portal')}
              className="block w-full bg-teal-600 text-white px-4 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer text-center"
            >
              Client Portal
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
